import { z } from "zod";

/** Identifier system for Junction wearable provider slug (e.g. "apple_health_kit", "fitbit"). */
export const WEARABLE_IDENTIFIER_SYSTEM_PROVIDER = "vibrant.wearable.provider";

/** Identifier system for Junction record IDs used for deduplication. */
export const WEARABLE_IDENTIFIER_SYSTEM_JUNCTION_ID = "vibrant.wearable.junction-id";

/** Identifier system for Junction user IDs stored on Device resources. */
export const WEARABLE_IDENTIFIER_SYSTEM_JUNCTION_USER = "vibrant.wearable.junction-user";

/** Schema for Junction source/provider payloads shared by wearable models. */
export const JunctionSourceSchema = z.object({
  provider: z.string().optional(),
  type: z.string().optional(),
  app_id: z.string().optional().nullable(),
  /** Source device the samples were recorded on (Junction sends this; keep it for attribution). */
  device_id: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  slug: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
});

export type JunctionSource = z.infer<typeof JunctionSourceSchema>;

/** Resolve the wearable provider slug from a Junction source object. */
export function getProviderSlug(source: JunctionSource | undefined): string {
  return source?.slug || source?.provider || "unknown";
}
